export default __webpack_public_path__ + "static/media/NEXT_DOOR.04b63e0f.png";